// extracted by mini-css-extract-plugin
module.exports = {"copyInviteLinkModal":"copyInviteLinkModal__caEMz","link":"link__+bMFH"};